module.exports = __webpack_public_path__ + "img/pump-md.f7083a3f.svg";